import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

import { mapState } from 'vuex';
// import EditProject from '@pt/components/edit-project-name/index.vue'
import { updateGmakerProject } from '@pt/api/gmaker/project.js';
import ProjectRename from '@com/components/project-rename/index.vue';

export default {
  name: 'commonTemplateCrumb.vue',
  props: {
    name: {
      type: String,
      required: true
    }
  },

  components: {
    ProjectRename: ProjectRename
  },

  data: function data() {
    return {
      // name: '',
    };
  },


  computed: _extends({}, mapState({
    id: function id(state) {
      return state.creative.template.id;
    },
    templateConfig: function templateConfig(state) {
      return state.creative.template.templateConfig || {};
    },
    isReadonly: function isReadonly(state) {
      return state.creative.template.isReadonly;
    }
  }), {
    path: function path() {
      var utils = {
        'common-template.custom': '/#/my-project/playable/normal'
      };
      return utils[this.$route.name] || '/#/my-project/playable/normal';
    },
    inputAttrs: function inputAttrs() {
      return {
        'show-word-limit': true,
        maxlength: 50,
        placeholder: this.$t('playTurbo.commonTemplate.creativeInfo.form.name.placeholder')
      };
    },
    rules: function rules() {
      return [{
        required: true,
        message: this.$t('playTurbo.videoProject.rulesTips'),
        trigger: 'change'
      }];
    }
  }),

  methods: {
    // 修改名称
    handleRename: function handleRename(name, oldName) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$store.commit('creative/template/updateTemplateConfigName', name); // 相当于乐观锁，先写入新名字，发现失败再回滚
                updateGmakerProject({
                  name: name,
                  project_id: _this.id
                }).catch(function () {
                  _this.$store.commit('creative/template/updateTemplateConfigName', oldName);
                });

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }
};